//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
export default {
  name: "LogSocketList",
  mixins: [JeecgListMixin],
  components: {},
  data: function data() {
    return {
      pagePath: '/sys/log/socket',
      pageTitle: '联网日志',
      isorter: {
        column: 'login_time',
        order: 'desc'
      },
      // 表头
      columns: [// {
      //     title: '序号',
      //     dataIndex: '',
      //     key: 'rowIndex',
      //     width: 60,
      //     align: "center",
      //     customRender: function (t, r, index) {
      //         return parseInt(index) + 1;
      //     }
      // },
      {
        dataIndex: 'clientIp',
        colName: 'client_ip',
        title: '客户端IP',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'clientPort',
        colName: 'client_port',
        title: '客户端端口',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'serverIp',
        colName: 'server_ip',
        title: '服务端IP',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'loginTime',
        colName: 'login_time',
        title: '登录时间',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'logoutTime',
        colName: 'logout_time',
        title: '退出时间',
        align: "center",
        sorter: true
      }]
    };
  },
  created: function created() {},
  computed: {},
  methods: {
    onDateLoginTime: function onDateLoginTime(value, dateArray) {
      this.queryParam.loginTimeStart = dateArray[0];
      this.queryParam.loginTimeEnd = dateArray[1];
    },
    onDateLogoutTime: function onDateLogoutTime(value, dateArray) {
      this.queryParam.logoutTimeStart = dateArray[0];
      this.queryParam.logoutTimeEnd = dateArray[1];
    }
  }
};